export default function AboutData() {
  return {
      link: 'https://player.vimeo.com/video/213549517',
      description: '',
      content: ''
  }

}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/term/VideoData.js